<template>
  <div class="box">
    <span class="version">version:{{ network.version }} device:{{ network.deviceId }}</span>
    <div class="hearder">
      <div class="row">
        <div class="name">{{ departmentName }}</div>
          <img style="width:33vw;margin:0 0 0 3vw" v-if="weekProductivity > 80 || weekProductivity === 80"  src="@/assets/visualization/hare.svg" />
          <img style="width:26vw;margin:1vh 0 0 3vw" v-if="(weekProductivity > 60 && weekProductivity < 80) || weekProductivity === 60" src="@/assets/visualization/rabbit.svg" />
          <img style="width:41vw;margin:3.2vh 0 0 3vw" v-if="weekProductivity > 40 && weekProductivity < 60"  src="@/assets/visualization/fastTortoise.svg" />
          <img style="width:25.4vw;margin:1.2vh 0 0 4vw" v-if="weekProductivity < 40 || weekProductivity === 40" src="@/assets/visualization/slowTortoise.svg" />
        <div class="date">
          <div>
            <span style="font-size: 30px;">{{ dateweek.day }} {{ dateweek.week }}</span>
            <span class="mock-block">
              <img class="icon" src="@/assets/visualization/calendar.svg" />
            </span>
          </div>
          <div>
            <span style="font-size: 30px;">{{ dateweek.time }}</span>
            <span class="mock-block">
              <img class="icon" src="@/assets/visualization/time.svg" />
            </span>
          </div>
          <div>
            <span style="font-size: 30px;color: red;" v-if="network.msg">{{network.msg}}</span>
          </div>
        </div>
      </div>
      <div class="overview">
        <div class="outputs">
          <div class="title">
            <span style="font-weight:normal">本周制令单</span>
            <span>{{ thisWeek.completedOrderTotal }}/{{ thisWeek.completedOrderTotal + thisWeek.unfinishedOrderTotal }}</span>
          </div>
          <div class="g-container" :style="{ 'background': 'rgb(221, 221, 221)' }">
            <template>
              <div class="g-progress" :style="{ 'width': `${percent}%` }"></div>
            </template>
          </div>
          <div style="text-align:right;font-weight:normal;margin-top:30px">
            {{ thisWeek.reportTotal }}/{{ thisWeek.planTotal }}pcs</div>
        </div>
      </div>
    </div>
    <div class="work-section">
      <div class="grid-container">
        <!-- <div class="grid-item" v-for="(item, indexs) in thisWeek.productionOrderKanBanModels" :key="indexs">
            {{item.productName}}
          </div> -->
        <div class="grid-item" v-for="(item) in carouselData" :style="{borderColor:getBorderColor(item)}">
          <div class="week">
            <!--小工单标识  -->
            <div v-if="item.type === 'SMALL_WORK_ORDER'" class="small-work-order">小</div>
            {{ currentWeek }}
          </div>
          <div style="position:relative; height:calc(100% - 42px)">
            <div v-if="item.iconUrl" style="width:100%;height:100%;margin:12px 18px 0 0">
              <img :src="item.iconUrl.url" style="width:100%;height:100%;object-fit: contain" />
            </div>
            <div v-else class="imgWrap">
              <img src="@/assets/visualization/defaultProduct.svg"
                style="width:80%;height:auto;vertical-align: middle;" />
            </div>
            <div v-if="item.prodOrderStatus && item.prodOrderStatus.value === 'ACCOMPLISH'||item.prodOrderStatus.value === 'CLOSE'" class="green-check-circle">
            </div>
            <!-- <div v-if="item.prodOrderStatus && item.prodOrderStatus.value === 'CLOSE'" class="close-check-circle"></div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 下周 -->
    <div class="nextWeek">
      <div class="title">
        <div>
          <span class="text">下周制令单</span>
          <span class="order-num">{{ nextWeek.completedOrderTotal + nextWeek.unfinishedOrderTotal }}</span>
        </div>
        <span
          class="product-num">{{ nextWeek.reportTotal }}/{{calc.add( nextWeek.planTotal , 0) }}pcs</span>
      </div>
      <div class="g-container" :style="{ 'background': 'rgb(193, 193, 193)' }">
        <template>
          <div class="g-progress" :style="{ 'width': `${nextWeekPercent}%`, 'background': 'rgb(112, 112, 112)' }"></div>
        </template>
      </div>
    </div>
    <!-- 逾期 -->
    <div class="overdue">
      <div class="title">
        <div>
          <span class="text">逾期制令单</span>
          <span class="order-num">{{ calc.add(overdue.completedOrderTotal , overdue.unfinishedOrderTotal) }}</span>
        </div>
        <span
          class="product-num">{{ overdue.reportTotal }}/{{ calc.add(overdue.planTotal , 0) }}pcs</span>
      </div>
      <div class="g-container" :style="{ 'background': 'rgb(193, 193, 193)' }">
        <template>
          <div class="g-progress" :style="{ 'width': `${overduePercent}%`, 'background': 'rgb(255, 255, 255)' }"></div>
        </template>
      </div>
    </div>
    <!-- <div class="this-week" v-for="(item, index) in viewData" :key="index">
      <div class="hearder" :style="{ 'background': item.title < '逾期制令单' ? 'rgb(1, 32, 61)' : 'rgb(246, 108, 108)' }">
        <div class="row">
          <div class="title">
            <div>{{ item.data && item.data.unfinishedOrderTotal }}</div>
            <div>{{ item.title }}</div>
          </div>
          <div class="progress-bar">
            <div class="scale">{{ item.data && item.data.unfinishedTotal }} / {{ item.data && item.data.completedTotal }}
              PCS</div>
            <div class="g-container"
              :style="{ 'background': item.title < '逾期制令单' ? 'rgb(63, 88, 110)' : 'rgb(249, 145, 146)' }">
              <template v-if="item.data && item.data.completedTotal == '0'">
                <div class="g-progress" :style="{ 'width': `${0 * 100}%` }"></div>
              </template>
              <template
                v-else-if="item.data && item.data.completedTotal != '0' && Number(item.data.unfinishedTotal) > Number(item.data.completedTotal)">
                <div class="g-progress" :style="{ 'width': `${100}%` }"></div>
              </template>
              <template v-else>
                <span v-if="item.data"> {{item.data.unfinishedTotal}}--{{item.data.completedTotal}}</span>  
                <div class="g-progress" v-if="item.data"
                  :style="{ 'width': `${Number(item.data.unfinishedTotal) / Number(item.data.completedTotal) * 100}%` }" />
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="work-section">
        <div class="grid-container">
          <div class="grid-item" v-for="(element, indexs) in item.itemShow" :key="indexs">
            <div>{{ element.productionNo }}</div>
            <div class="odd-number">
              <img class="img" v-if="element.iconUrl != null && element.iconUrl != ''" :src="element.iconUrl.url" />
              <img class="img" v-else src="@/assets/visualization/defaultProduct.svg" />
              <div class="description">
                <div>{{ element.productCode }}</div>
                <div>{{ element.productName }}</div>
                <div class="g-container">
                  <template v-if="element.plannedQuantity == '0'">
                    <div class="g-progress" :style="{ 'width': `${0 * 100}%` }"></div>
                  </template>
                   <template
                    v-else-if="element.plannedQuantity != '0' && Number(element.reportQuantity) > Number(element.plannedQuantity)">
                    <div class="g-progress" :style="{ 'width': `${100}%` }"></div>
                  </template>
                 <template v-else>
                    <div class="g-progress"
                      :style="{ 'width': `${Number(element.reportQuantity) / Number(element.plannedQuantity) * 100}%` }" />
                  </template>
                </div>
                <div>{{ element.plannedQuantity }} PCS</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { calc } from '../../utils/tools'

export default {
  props: {
    dateweek: {
      type: Object
    },
    network: {
            type: Object
        },
    payload: {
      type: Array,
      default: () => [],
    },
    organizationName: String
  },
  data() {
    return {
      calc,
      code: '',
      weekProductivity:0,
      viewData: [
        {
          id: '1',
          title: '本周制令单',
          data: {},
          productionOrderKanBanModels: [],
          itemShow: [],
        },
        {
          id: '2',
          title: '下周制令单',
          data: {},
          productionOrderKanBanModels: [],
          itemShow: [],
        },
        {
          id: '3',
          title: '逾期制令单',
          data: {},
          productionOrderKanBanModels: [],
          itemShow: [],
        },
      ],
      refreshInterval: '', //刷新时间
      urlCode: '',
      refreshData: null,
      carouselData: null,
      thisWeek: {},
      departmentName: '',
      // 当前时间
      newDate: '',
      nowDate: '',
      nowWeek: '',
      currentWeek: 0,
      nextWeek: {},
      overdue: {},
    }
  },
  watch: {
    payload() {
      this.setpayload()
    }
  },
  created() {
    this.setpayload()
    this.getYearWeek()
  },
  computed: {
    percent() {
      if (this.thisWeek) {
        let p = this.thisWeek.completedTotal / (this.thisWeek.completedTotal + this.thisWeek.unfinishedTotal) * 100
        return p > 100 ? 100 : p.toFixed(0)
      }
      return 0
    },
    // 本周完成制令单数量
    compeletedNumOfThisWeek() {
      if (this.thisWeek.productionOrderKanBanModels && this.thisWeek.productionOrderKanBanModels.length) {
        let data = this.thisWeek.productionOrderKanBanModels.reduce((sum, item) => {
          return sum + item.reportQuantity
        }, 0)
        return data
      } else {
        return 0
      }
    },
    // 本周总制令单数量
    totalOfThisWeek() {
      if (this.thisWeek.productionOrderKanBanModels && this.thisWeek.productionOrderKanBanModels.length) {
        let data = this.thisWeek.productionOrderKanBanModels.reduce((sum, item) => {
          return sum + item.plannedQuantity
        }, 0)
        return data
      } else {
        return 0
      }
    },
    // 下周完成制令单数量
    compeletedNumOfNextWeek() {
      if (this.nextWeek.productionOrderKanBanModels && this.nextWeek.productionOrderKanBanModels.length) {
        let data = this.nextWeek.productionOrderKanBanModels.reduce((sum, item) => {
          return sum + item.reportQuantity
        }, 0)
        return data
      } else {
        return 0
      }
    },
    // 下周总制令单数量
    totalOfNextWeek() {
      if (this.nextWeek.productionOrderKanBanModels && this.nextWeek.productionOrderKanBanModels.length) {
        let data = this.nextWeek.productionOrderKanBanModels.reduce((sum, item) => {
          return sum + item.plannedQuantity
        }, 0)
        return data
      } else {
        return 0
      }
    },
    nextWeekPercent() {
      if (this.nextWeek) {
        let p = this.nextWeek.completedTotal / (this.nextWeek.completedTotal + this.nextWeek.unfinishedTotal) * 100
        return p > 100 ? 100 : p.toFixed(0)
      }
      return 0
    },
    // 逾期完成制令单数量
    compeletedNumOfOverdue() {
      if (this.overdue.productionOrderKanBanModels && this.overdue.productionOrderKanBanModels.length) {
        let data = this.overdue.productionOrderKanBanModels.reduce((sum, item) => {
          return sum + item.reportQuantity
        }, 0)
        return data
      } else {
        return 0
      }
    },
    // 逾期总制令单数量
    totalOfOverdue() {
      if (this.overdue.productionOrderKanBanModels && this.overdue.productionOrderKanBanModels.length) {
        let data = this.overdue.productionOrderKanBanModels.reduce((sum, item) => {
          return sum + item.plannedQuantity
        }, 0)
        return data
      } else {
        return 0
      }
    },
    overduePercent() {
      if (this.overdue) {
        let p = this.overdue.completedTotal / (this.overdue.completedTotal + this.overdue.unfinishedTotal) * 100
        return p > 100 ? 100 : p.toFixed(0)
      }
      return 0
    }
  },
  methods: {
    setpayload() {
      let arr = this.payload
      this.viewData[0].productionOrderKanBanModels = []
      this.viewData[1].productionOrderKanBanModels = []
      this.viewData[2].productionOrderKanBanModels = []
      if (arr.length > 0) {
        this.thisWeek = arr[0].thisWeekKanBan
        this.weekProductivity = arr[0].weekProductivity
        this.departmentName = arr[0].departmentName
        this.nextWeek = arr[0].nextWeekKanBan
        this.overdue = arr[0].overdueKanBan
        arr.forEach(item => {
          if (item.thisWeekKanBan) {
            this.viewData[0].data = item.thisWeekKanBan
            this.viewData[0].productionOrderKanBanModels = item.thisWeekKanBan.productionOrderKanBanModels
            let thisArr = item.thisWeekKanBan.productionOrderKanBanModels.slice(0, 4)
            this.viewData[0].itemShow = thisArr
          }
          if (item.nextWeekKanBan) {
            this.viewData[1].data = item.nextWeekKanBan
            this.viewData[1].productionOrderKanBanModels = item.nextWeekKanBan.productionOrderKanBanModels
            let nextArr = item.nextWeekKanBan.productionOrderKanBanModels.slice(0, 4)
            this.viewData[1].itemShow = nextArr
          }
          if (item.overdueKanBan) {
            this.viewData[2].data = item.overdueKanBan
            this.viewData[2].productionOrderKanBanModels = item.overdueKanBan.productionOrderKanBanModels
            let overArr = item.overdueKanBan.productionOrderKanBanModels.slice(0, 4)
            this.viewData[2].itemShow = overArr
          }
        });
        // this.taskCarousel()
        if (this.thisWeek.productionOrderKanBanModels.length <= 15) {
          this.carouselData = this.thisWeek.productionOrderKanBanModels
        } else {
          this.carousel()
        }
      }
    },
    carousel() {
      let count = 0
      this.carouselData = this.thisWeek.productionOrderKanBanModels.slice(count * 15, (count + 1) * 15)
      if(this.carouselTimer) return
      this.carouselTimer = setInterval(() => {
        if (this.thisWeek.productionOrderKanBanModels.length > (count + 1) * 15) {
          count++
        } else {
          count = 0
        }
        this.carouselData = this.thisWeek.productionOrderKanBanModels.slice(count * 15, (count + 1) * 15)
      }, 30000)
    },
    // 获取当前周是第几周
    getYearWeek() {
      let nowDate = new Date();
      let firstDay = new Date();
      firstDay.setMonth(0);//设置1月
      firstDay.setDate(1);//设置1号
      let diffDays = Math.ceil((nowDate - firstDay) / (24 * 60 * 60 * 1000));
      let week = Math.ceil(diffDays / 7);
      this.currentWeek = week === 0 ? 1 : week;
    },
    clearAllInterval() {
      clearInterval(this.carouselData)
      clearInterval(this.carouselTimer)
      this.carouselTimer = null
      this.carouselData = null
    },
    // 边框颜色
    getBorderColor(item){
      let status = item.prodOrderStatus&&item.prodOrderStatus.value
      if(status=='ACCOMPLISH'){
        return 'green'
      }else if(item.overdue){
        return '#FA5151'
      }else if(status =='AWAIT_PRODUCTION'){
        return '#ddd'
      }else if(status =='IN_PRODUCTION'){
        return '#1890ff'
      }else {
        return '#333'
      }
    }
  },
  // 销毁时清除计时器
  beforeDestroy: function () {
    this.clearAllInterval()
  },
}
</script>
<style scoped lang="less">
.box {
  height: 100%;
  width: 100%;
  font-weight: bolder;

  .hearder {
    // height: 640px;
    width: 100vw;
    background: #D0E9FF;
    font-size: 54px;
    color: #333;
    padding: 40px 50px 20px;
    box-sizing: border-box;

    .row:first-child {
      margin-bottom: 50px;
      display: flex;
      justify-content: space-between;

      .name {
        text-align: left;
        width: 220px;
        word-wrap: break-word;
      }

      div {
        .efficiency {
          font-size: 64px;
        }
      }

      .date {
        text-align: right;

        .icon {
          width: 30px;
          height: auto;
          vertical-align: middle;
        }
      }
    }

    .row:last-child {
      // font-size: 110px;
    }

    .overview {
      color: #fff;
      height: 295px;

      &>div {
        text-align: center;
        border-radius: 10px 10px 10px 10px;
        padding: 40px;
        height: 295px;
        box-sizing: border-box;

        .title {
          font-size: 60px;
          margin-bottom: 24px;
          display: flex;
          justify-content: space-between;
        }

        .number {
          font-size: 80px;
        }

        .number-60 {
          font-size: 60px;
        }

        .number-40 {
          font-size: 40px;
        }
      }

      .outputs {
        background-color: #333;
      }

      .high-rate {
        background-color: #00B578;
      }

      .middle-rate {
        background-color: #F5B130;
      }

      .low-rate {
        background-color: #FA5151;
      }

      .g-container {
        width: 100%;
        height: 30px;
        border-radius: 25px;

        .g-progress {
          // width: 70%;
          height: inherit;
          border-radius: 25px;
          background: #1890FF;
        }
      }
    }
  }

  .work-section {
    height: calc(100% - 1292px);
    width: 100%;
    padding: 20px 0;
    overflow: hidden;
  }

  .grid-container {
    display: grid;
    grid-gap: 14px;
    grid-template-columns: repeat(5, 18.8%);
    background-color: rgb(255, 255, 255);
    width: calc(100% - 100px);
    margin: 0 auto;
  }

  .grid-item {
    height: 203px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    border: 3px solid #333333;
    box-sizing: border-box;
    padding: 15px;

    .week {
      height: 30px;
      background: #333333;
      border-radius: 5px 5px 0px 0px;
      font-size: 30px;
      color: #fff;
    }

    .imgWrap {
      width: 100%;
      height: 100%;
      border-radius: 5px 5px 5px 5px;
      border: 2px solid #DDDDDD;
      box-sizing: border-box;
      margin: 12px 18px 0 0;
      padding: 4px 0 6px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .g-container {
      width: 100%;
      height: 30px;
      border-radius: 25px;
      background: rgb(226, 226, 226);

      .g-progress {
        // width: 70%;
        height: inherit;
        border-radius: 25px;
        background: rgb(83, 196, 26);
      }
    }
  }

  .nextWeek,
  .overdue {
    height: 160px;
    padding: 32px 40px;
    border-radius: 10px;
    width: calc(100% - 100px);
    margin: 0 auto;
    box-sizing: border-box;

    .g-container {
      width: 100%;
      height: 20px;
      border-radius: 25px;
      margin: 5px 0 0;

      .g-progress {
        // width: 70%;
        height: inherit;
        border-radius: 25px;
      }
    }

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .text {
      font-size: 50px;
      font-weight: normal;
      margin-right: 20px;
    }

    .order-num {
      font-size: 60px;
      font-weight: bold;
      vertical-align: top;
    }

    .product-num {
      font-size: 35px
    }
  }

  .nextWeek {
    background: #ddd;
    color: #707070;
    margin: 40px auto;
  }

  .overdue {
    background: #FA5151;
    color: #fff;
  }

  .green-check-circle {
    position: absolute;
    right: -4px;
    bottom: 0px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 10px solid rgba(0, 181, 120, 1);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .green-check-circle::before {
    content: "";
    display: block;
    width: 20px;
    height: 10px;
    border: 6px solid rgba(0, 181, 120, 1);
    border-right: none;
    border-top: none;
    transform: rotate(-45deg) translate(2px, 0px);
  }

  .close-check-circle {
    position: absolute;
    right: -4px;
    bottom: 0px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 10px solid #FA5151;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }

  .close-check-circle::before {
    content: "关";
    display: block;
    color: #FA5151;
    font-size: 20px;
  }

  .small-work-order {
    display: inline-block;
    border-radius: 5px 0 0;
    width: 24%;
    height: 30px;
    line-height: 30px;
    vertical-align: text-top;
    margin-right: -24%;
    color: #fff;
    font-size: 24px;
    background: rgb(112, 112, 112);
    font-weight: normal;
    text-align: center;
    float: left;
  }

  .this-week {
    height: 33.3%;
    width: 100%;
    // display: flex;
    // margin-bottom: 2.5vh;
    // background: pink;

    .hearder {
      height: 25%;
      width: 100%;
      font-size: 54px;
      color: #fff;

      .row {
        width: calc(100vw - 80px);
        height: 100%;
        margin: auto;
        display: flex;

        .title {
          width: 50%;
          // height: 100%;
          margin-top: 10px;
        }

        .progress-bar {
          width: 50%;
          // height: 100%;
          margin-top: 10px;

        }
      }
    }

    .work-section {
      height: 75%;
      width: 100%;
      background: pink;

      .grid-container {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: auto auto;
        background-color: rgb(255, 255, 255);
        padding: 10px;
        height: 96%;
      }

      .grid-item {
        background-color: rgb(246, 246, 246);
        // border: 1px solid rgba(0, 0, 0, 0.8);
        // padding: 20px;
        font-size: 50px;
        text-align: center;

        div:first-child {
          text-align: left;
        }

        .odd-number {
          display: flex;

          .img {
            width: 50%;
            height: 147px;
          }

          .description {
            width: 50%;
            height: 147px;
            text-align: left;
            font-size: 25px;

            div {
              margin-bottom: 8px;
            }

            div:last-child {
              text-align: right;
              margin-bottom: 0px;
            }

            .g-container {
              width: 100%;
              height: 30px;
              border-radius: 25px;
              background: rgb(226, 226, 226);

              .g-progress {
                // width: 70%;
                height: inherit;
                border-radius: 25px;
                background: rgb(83, 196, 26);
              }
            }
          }
        }
      }
    }
  }
}
.version{
    font-size:20px;
    position: absolute;
    left: 0px;
    top: 10px;
    color:rgba(0, 0, 0, 0.3)
}
</style>



// WEBPACK FOOTER //
// src/views/production/Task.vue